import {injectable} from 'inversify'
import {FetchOptionsFactoryProxyInterface} from '@/src/core/domain/page/functions/fetch/types'

@injectable()
export class ProfileReservationsFetchOptionsFactoryProxy implements FetchOptionsFactoryProxyInterface {
  create() {
    return async () => ({ignore: true})
  }
}
